import config from "@/config/config";
import { headers } from "./auth.headers";
import { formatQueryString } from "@/helpers/query-string";
import { Payment } from "@/domain/payment.model";
import { IPaginateVueTable } from "@/interfaces/IPaginateVueTable";
import httpClient from "@/helpers/http-client";

export default class PaymentService {
  private static urlApiBase = config.url_api_base;

  static insert = (data: Payment): Promise<Payment> => {
    return httpClient
      .request<Payment>({
        url: `${this.urlApiBase}/payment`,
        method: "POST",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static update = (data: Payment): Promise<Payment> => {
    return httpClient
      .request<Payment>({
        url: `${this.urlApiBase}/payment/${data.id}`,
        method: "PATCH",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static get = (id: string): Promise<Payment> => {
    const url = `${this.urlApiBase}/payment/${id}`;

    return httpClient
      .request<Payment>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static list = (
    offset?: number,
    limit?: number,
    order?: string,
    sort?: string,
    filter?: string,
  ): Promise<IPaginateVueTable<Payment>> => {
    const query = formatQueryString(offset, limit, order, sort, filter, true);
    const url = `${this.urlApiBase}/payment${query}`;

    return httpClient
      .request<IPaginateVueTable<Payment>>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static listActive = (): Promise<Payment[]> => {
    const url = `${this.urlApiBase}/payment/list-active`;

    return httpClient
      .request<Payment[]>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static delete = (id: string): Promise<Payment> => {
    const url = `${this.urlApiBase}/payment/${id}`;

    return httpClient
      .request<Payment>({
        url,
        method: "DELETE",
        headers: headers(),
      })
      .then(result => result?.body);
  };
}
